var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#cecdcd;stroke-width:0.5px;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -55.42,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.34,
    y: 0.34,
    width: 39.33,
    height: 39.33,
    rx: 2.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 3.65,
    y1: 17.11,
    x2: -39.26,
    y2: 60.02
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.49,
    y1: -2.95,
    x2: 0.49,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.07,
    y1: -2.95,
    x2: 6.07,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.65,
    y1: -2.95,
    x2: 11.65,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 17.23,
    y1: -2.95,
    x2: 17.23,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22.82,
    y1: -2.95,
    x2: 22.82,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.4,
    y1: -2.95,
    x2: 28.4,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.98,
    y1: -2.95,
    x2: 33.98,
    y2: 52.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.56,
    y1: -2.95,
    x2: 39.56,
    y2: 52.92
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.9fd0c2156bb32f0bae4ff9210568fd25.svg";
export { ForwardRef as ReactComponent };